<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/zone-setup/apn" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditAPNZone") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.APN')"
              >
                <vs-input
                  :label="$t('setup.label.APN')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="apn"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ImpactCategory") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ImpactCategory')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="impactCategory"
                    :options="networkEleData"
                    :reduce="(obj) => obj.mCodeValue"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|numeric"
                v-slot="{ errors }"
                :name="$t('setup.label.Rank')"
              >
                <vs-input
                  v-model="rank"
                  :label="$t('setup.label.Rank')"
                  class="w-full mb-2 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="editApnZoneTemplete"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
export default {
  data() {
    return {
      networkEleData: [],
      apn: "",
      impactCategory: "",
      impactCategoryId: "",
      rank: "",
      systemById: {},
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      numberZoneTemplate: (state) => state.zoneSetup.numberZoneTemplate,
      numberZoneId: (state) => state.zoneSetup.numberZoneId,
    }),
  },
  methods: {
    async getApnZoneTemp() {
      try {
        await this.$store.dispatch("zoneSetup/fetchNumberZoneTemplate");
        this.networkEleData = this.numberZoneTemplate;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editApnZoneTemp() {
      try {
        await this.$store.dispatch(
          "zoneSetup/fetchApnZoneIdAction",
          this.$route.params.id
        );
        this.systemById = this.numberZoneId;
        this.apn = this.systemById.apn;
        this.impactCategory = this.systemById.impactCategory;
        this.impactCategoryId = this.systemById.impactCategoryId;
        this.rank = this.systemById.rank;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editApnZoneTemplete() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        apn: this.apn,
        impactCategory: this.impactCategory,
        impactCategoryId: this.impactCategoryId,
        rank: this.rank,
      };
      try{
      await this.$store.dispatch("zoneSetup/updateApnZoneAction", {
        id: this.$route.params.id,
        data: payload,
      });
      this.$swal({
        title: "Success",
        icon: "success",
        text: "APN Zone Created Successfully!",
        type: "success",
      });
      this.$router.push(`/setup/zone-setup/apn`);
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    cancel() {
      this.$router.push(`/setup/zone-setup/apn`);
    },
  },
  watch: {},
  mounted() {
    this.getApnZoneTemp();
    this.editApnZoneTemp();
  },
};
</script>
